import { initializeErrorReporting } from '@eventbrite/error-reporting';
// Import below has to be performed first so that other parts of the app do not fail
// import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import './components/lean-eds/css/eds.css';
import debugHelper from './helpers/debug-helper';
import appDirector from './managers/app-director';
import App from './app';
import {
    getLocaleOverride,
    setupAsync,
    getParentLocale,
} from '@eventbrite/i18n';

const init = (id) => {
    // retrieve data from server to hydrate the client
    const props = window.__SERVER_DATA__ || {};

    ReactDOM.render(<App {...props} />, document.getElementById(id));
};

const props = window.__SERVER_DATA__ || {};

const parentLocale = getParentLocale(
    getLocaleOverride() || props.env.localeInfo.locale,
);

const main = async () => {
    initializeErrorReporting();
    try {
        if (parentLocale !== 'en_US') {
            await setupAsync({
                parentLocale,
                translations:
                    /* webpackChunkName: "venue-map-i18n-translation" */ import(
                        `./i18n/translations/${parentLocale}.json`
                    ),
            });
        }
    } finally {
        //DebugHelper will check localStorage.debugUrl=
        //If we have a debugUrl, the app will become an iframeProxy wrapper and will load
        // the debugUrl behaving as a passthrough for requests
        // It will pass down the insideIFrameProxy query param to the inner frame so that it knows that it is being wrapped
        appDirector.setPageParamsFromUrl();

        const urlParams = appDirector.getPageParams();

        debugHelper.aInit({ urlParams }).then(() => {
            if (!debugHelper.isIframeProxy()) {
                Promise.all([appDirector.aInit()]).then(() => {
                    init('root');
                });
            }
        });
    }
};
main();

// We add meta tags so that we cannot zoom
const _addMetaToAvoidScaling = () => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        const meta = document.createElement('meta');

        meta.content =
            'width=device-width, initial-scale=1 initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
        meta.name = 'viewport';
        document.head.appendChild(meta);
    }
};

_addMetaToAvoidScaling();
